import { validate } from './index.js';

const validatorMixin = {
  props: {
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // By default no validation rules are specified.
      validationRules: [],

      // By default required fields are validated using 'required' validator.
      requiredValidator: 'required'
    };
  },
  methods: {
    validate() {
      const validationErrors = [];

      this.validationRules.forEach(rule => {
        if (rule !== this.requiredValidator && !this.value) {
          return;
        }

        if (!validate(rule, JSON.parse(JSON.stringify(this.value)))) {
          validationErrors.push(rule);
        }
      });

      this.$emit('update:validationErrors', validationErrors);
    }
  },
  created() {
    if (this.required) {
      this.validationRules.push(this.requiredValidator);
    }
  }
};

export default validatorMixin;
